var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "editable",
          rawName: "v-editable",
          value: _vm.blok,
          expression: "blok",
        },
      ],
      staticClass: "image-block",
      class: _vm.styleClasses,
      style: _vm.styles,
    },
    [
      _vm.rawLink
        ? _c(
            "a",
            {
              attrs: {
                href: _vm.formattedLink,
                target: _vm.linkTarget,
                "aria-label": "Image link",
              },
            },
            [
              !_vm.rawLink
                ? _c("img", {
                    staticClass: "lazyload",
                    attrs: {
                      src: _vm.imageSrc,
                      "data-sizes": "auto",
                      "data-src": _vm.imageDatasrc,
                      "data-srcset": _vm.imageDataset,
                      alt: "Article image",
                    },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.rawLink
        ? _c("img", {
            staticClass: "lazyload",
            attrs: {
              src: _vm.imageSrc,
              "data-sizes": "auto",
              "data-src": _vm.imageDatasrc,
              "data-srcset": _vm.imageDataset,
              alt: "Article image",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.blok.caption
        ? _c("figcaption", { domProps: { innerHTML: _vm._s(_vm.captionHtml) } })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }